// eslint-disable-next-line no-unused-vars
import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { hasKioskoAuthToken } from "./authUtils";

// Componente para rutas que requieren autenticación
export const PrivateRoute = ({ children }) => {
  const token = hasKioskoAuthToken();
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

// Componente para rutas que no deben estar accesibles cuando el usuario está autenticado
export const RestrictedRoute = ({ children }) => {
  const token = hasKioskoAuthToken();

  if (token) {
    return <Navigate to="/banners" replace />;
  }
  return children;
};

RestrictedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
